import { connect } from 'react-redux';
import Stopwatch from './stopwatch';

const mapeStateToProps = ({ chat, voipChat }, props) => ({
  ...chat,
  ...voipChat,
  ...props
});

export default connect(mapeStateToProps)(Stopwatch);
